// src/components/CreatePostsCard.js

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    CardContent,
    CardActions,
    IconButton,
    Typography,
    Box,
    useTheme,
    Avatar,
    Tooltip,
} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';

import { keyframes } from '@emotion/react';

const CreatePostsCard = () => {
    const theme = useTheme();

    // Card styling
    const cardBackgroundColor = theme.palette.mode === 'dark' ? '#30334E' : '#FFFFFF';

    return (
        <Card
            elevation={4}
            sx={{
                position: 'relative',
                height: '100%',
                width: "auto",
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: cardBackgroundColor,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
                },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar
                        sx={{
                            bgcolor: 'transparent',
                            mr: 0.5,
                            width: 56,
                            height: 56,
                        }}
                    >
                        <CreateIcon sx={{ color: 'text.primary', fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h5" sx={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>
                        Create Posts
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    Craft engaging content to connect with your audience across multiple platforms.
                </Typography>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                    }}
                >
                    {[FacebookIcon, InstagramIcon, PinterestIcon].map((IconComponent, index) => (
                        <Tooltip title={['Facebook', 'Instagram', 'Pinterest'][index]} key={index}>
                            <Avatar
                                sx={{
                                    bgcolor: theme.palette.background.paper,
                                    color: theme.palette.text.primary,
                                    width: 32,
                                    height: 32,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    //transition: 'transform 0.2s, box-shadow 0.2s',
                                    
                                }}
                            >
                                <IconComponent fontSize="small" />
                            </Avatar>
                        </Tooltip>
                    ))}
                </Box>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                <IconButton
                    component={RouterLink}
                    to="/pchannels?action=createPost"
                    sx={{ color: theme.palette.primary.main }}
                >
                    <ArrowForwardIcon />
                </IconButton>
            </CardActions>
        </Card>
    );
};

export default CreatePostsCard;
